import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { routes } from "../../../routers/routes";

const polaroidImages = [
  "/assets/images/other/journey/KL TO BANGKOK 1.jpg",
  "/assets/images/other/journey/KL TO BANGKOK 2.jpg",
  "/assets/images/other/journey/KL TO BANGKOK 3.jpg",
  "/assets/images/other/journey/KL TO BANGKOK 4.jpg",
];

const stripImages = [
  "/assets/images/other/journey/Bottom image/1.jpg",
  "/assets/images/other/journey/Bottom image/2.jpg",
  "/assets/images/other/journey/Bottom image/3.jpg",
  "/assets/images/other/journey/Bottom image/4.jpg",
  "/assets/images/other/journey/Bottom image/DSC05900 (1).jpg",
];

const galleryImages = [
  "/assets/images/other/journey/Bottom image/1.jpg",
  "/assets/images/other/journey/Bottom image/2.jpg",
  "/assets/images/other/journey/Bottom image/3.jpg",
  "/assets/images/other/journey/Bottom image/4.jpg",
  "/assets/images/other/journey/Bottom image/DSC05900 (1).jpg",
  "/assets/images/other/journey/Bottom image/DSC06556.jpg",
  "/assets/images/other/journey/Bottom image/DSC06564.jpg",
  "/assets/images/other/journey/Bottom image/DSC06729.jpg",
  "/assets/images/other/journey/Bottom image/DSC06760.jpg",
  "/assets/images/other/journey/Bottom image/DSC06985.jpg",
  "/assets/images/other/journey/Bottom image/DSC07065.jpg",
  "/assets/images/other/journey/Bottom image/FYD00061.jpg",
  "/assets/images/other/journey/Bottom image/FYD00326.jpg",
  "/assets/images/other/journey/Bottom image/FYD00393.jpg",
  "/assets/images/other/journey/Bottom image/FYD00804.jpg",
  "/assets/images/other/journey/Bottom image/FYD02248.jpg",
  "/assets/images/other/journey/Bottom image/FYD02478.jpg",
  "/assets/images/other/journey/Bottom image/FYD02727.jpg",
  "/assets/images/other/journey/Bottom image/FYD02733.jpg",
  "/assets/images/other/journey/Bottom image/FYD02737.jpg",
];

const showroomImages = [
  "/assets/images/other/journey/Every Journal Make/DSC06507.jpg",
  "/assets/images/other/journey/Every Journal Make/DSC06579.jpg",
  "/assets/images/other/journey/Every Journal Make/FYD02142.jpg",
];

const OurJourneyContainer = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openLightbox = (index: number) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const goPrev = useCallback(() => {
    setLightboxIndex((i) => (i - 1 + galleryImages.length) % galleryImages.length);
  }, []);

  const goNext = useCallback(() => {
    setLightboxIndex((i) => (i + 1) % galleryImages.length);
  }, []);

  useEffect(() => {
    if (!lightboxOpen) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightboxOpen, goPrev, goNext]);

  return (
    <>
      {/* Hero */}
      <section
        className="journey-hero-section"
        style={{ backgroundImage: "url('/assets/images/other/journey/BANNER PHOTO.jpg')" }}
      >
        <div className="journey-hero-inner">
          <Container>
            <Row>
              <Col lg={{ size: 5, offset: 7 }} md={{ size: 7, offset: 5 }}>
                <span className="journey-label">OUR JOURNEY</span>
                <h1 className="journey-hero-title">Driven by Passion.<br />Built on Experiences.</h1>
                <p className="journey-hero-desc">
                  From the streets of Kuala Lumpur to the roads of Bangkok a 5 day journey
                  that reminded us why we do what we do.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* The Beginning */}
      <section className="journey-dark-section">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={4}>
              <h2 className="journey-heading">More Than Just<br />A Car Dealer</h2>
              <p className="journey-text">
                CC Autoworld was built from a shared passion for cars, driving, and the people who enjoy them.
              </p>
              <p className="journey-text">
                We believe buying or selling a car should be transparent, honest, and enjoyable.
              </p>
              <p className="journey-text">
                We don&apos;t just sell cars.<br />
                We build trust, relationships,<br />
                and a community of people<br />
                who share the same passion.
              </p>
            </Col>
            <Col lg={8}>
              <Row className="g-3">
                <Col xs={12} lg={8}>
                  <div className="journey-img-block journey-img-tall">
                    <img src="/assets/images/other/journey/More Than JustA Car Dealer.jpg" alt="CC AutoWorld showroom" />
                  </div>
                </Col>
                <Col xs={12} lg={4}>
                  <div className="journey-img-block journey-img-tall">
                    <img src="/assets/images/other/journey/YOUR TRUSTED CAR DEALER.jpg" alt="CC AutoWorld trusted dealer" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Das Treffen Journey */}
      <section className="journey-dark-section journey-treffen-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={4}>
              <div className="journey-map-wrap">
                <img src="/assets/images/other/journey/KL TO BANGKOK MAIN.jpg" alt="KL to Bangkok route" className="w-100" />
              </div>
            </Col>
            <Col lg={4}>
              <span className="journey-label">DAS TREFFEN X JOURNEY</span>
              <h2 className="journey-heading">KL to Bangkok<br />5 Days. One Journey.</h2>
              <p className="journey-text">
                In December 2025, CC Autoworld joined Das Treffen X with our 2008 Porsche Cayenne GTS,
                the 10th anniversary of one of the region&apos;s most iconic Porsche gatherings.
              </p>
              <p className="journey-text">
                What started as a drive from Kuala Lumpur to Bangkok became more than just a journey
                across borders. Over 1,800KM, we experienced changing roads, new challenges,
                unforgettable moments, and the kind of friendships that are built through a shared
                passion for cars.
              </p>
              <p className="journey-text">
                For us, it was never just about reaching the destination. It was about the drive,
                the people, and being part of a community that truly lives the same passion.
              </p>
            </Col>
            <Col lg={4}>
              <div className="journey-polaroid-cluster">
                {polaroidImages.map((src, i) => (
                  <div key={i} className="journey-polaroid">
                    <img src={src} alt={`journey moment ${i + 1}`} />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Photo Strip */}
      <div className="journey-photo-strip">
        {/* Items 0-2: always photos */}
        {stripImages.slice(0, 3).map((src, i) => (
          <div key={i} className="journey-strip-item" onClick={() => openLightbox(i)} style={{ cursor: "pointer" }}>
            <img src={src} alt={`journey photo ${i + 1}`} />
          </div>
        ))}
        {/* Item 3: photo on desktop, MORE on mobile */}
        <div className="journey-strip-item journey-strip-last" onClick={() => openLightbox(3)} style={{ cursor: "pointer" }}>
          <img src={stripImages[3]} alt="journey photo 4" />
          <div className="journey-strip-overlay d-flex d-md-none">
            <span>+{galleryImages.length - 3} MORE</span>
          </div>
        </div>
        {/* Item 4: desktop-only MORE */}
        <div className="journey-strip-item journey-strip-last d-none d-md-flex" onClick={() => openLightbox(4)} style={{ cursor: "pointer" }}>
          <img src={stripImages[4]} alt="journey photo 5" />
          <div className="journey-strip-overlay">
            <span>+{galleryImages.length - stripImages.length + 1} MORE</span>
          </div>
        </div>
      </div>

      {/* What We Bring Back */}
      <section className="journey-dark-section">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={4}>
              <h2 className="journey-heading">Every Journey<br />Makes Us Better</h2>
              <p className="journey-text">
                Every kilometer, every experience, every challenge on the road shapes how we select,
                inspect, and deliver every car to you today.
              </p>
            </Col>
            <Col lg={8}>
              {/* Desktop: 3-column grid */}
              <Row className="g-3 d-none d-lg-flex">
                {showroomImages.map((src, i) => (
                  <Col xs={4} key={i}>
                    <div className="journey-img-block journey-img-showroom">
                      <img src={src} alt={`showroom ${i + 1}`} />
                    </div>
                  </Col>
                ))}
              </Row>
              {/* Mobile: autoplay landscape slideshow */}
              <div className="d-lg-none">
                <Swiper
                  modules={[Autoplay]}
                  slidesPerView={1}
                  autoplay={{ delay: 2500, disableOnInteraction: false }}
                  loop={true}
                  style={{ borderRadius: "8px" }}
                >
                  {showroomImages.map((src, i) => (
                    <SwiperSlide key={i}>
                      <div className="journey-showroom-slide">
                        <img src={src} alt={`showroom ${i + 1}`} />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section className="journey-cta-section">
        <Container className="position-relative">
          <div className="text-center journey-cta-content">
            <span className="journey-label">THE JOURNEY CONTINUES</span>
            <h2 className="journey-cta-title">Your Next Journey Starts Here</h2>
            <p className="journey-text">
              Whether you&apos;re buying, selling, or just exploring. We&apos;re here to make your
              next move the right one.
            </p>
            <div className="d-flex gap-3 justify-content-center flex-wrap mt-4">
              <Link to={routes.Car.Listing.CarLeftList} className="journey-cta-btn">
                View Our Inventory &rarr;
              </Link>
              <Link to={routes.Pages.Other.ConsignWithUs} className="journey-cta-btn">
                Consign With Us &rarr;
              </Link>
            </div>
          </div>
        </Container>
        <div className="journey-cta-deco" aria-hidden="true">
          <svg viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 280 Q100 200 160 150 Q220 100 300 60 Q350 35 380 20" stroke="rgba(255,255,255,0.2)" strokeWidth="2" strokeDasharray="8 6" fill="none" />
            <circle cx="380" cy="20" r="10" fill="rgba(var(--theme-color),1)" />
            <path d="M380 8 L374 20 L380 17 L386 20 Z" fill="#fff" />
          </svg>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxOpen && (
        <div className="journey-lightbox" onClick={closeLightbox}>
          <button className="journey-lightbox-close" onClick={closeLightbox}>&times;</button>
          <button className="journey-lightbox-prev" onClick={(e) => { e.stopPropagation(); goPrev(); }}>&#8249;</button>
          <div className="journey-lightbox-img-wrap" onClick={(e) => e.stopPropagation()}>
            <img src={galleryImages[lightboxIndex]} alt={`gallery ${lightboxIndex + 1}`} />
          </div>
          <button className="journey-lightbox-next" onClick={(e) => { e.stopPropagation(); goNext(); }}>&#8250;</button>
          <div className="journey-lightbox-counter">{lightboxIndex + 1} / {galleryImages.length}</div>
          <div className="journey-lightbox-thumbs" onClick={(e) => e.stopPropagation()}>
            {galleryImages.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`thumb ${i + 1}`}
                className={i === lightboxIndex ? "active" : ""}
                onClick={() => setLightboxIndex(i)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default OurJourneyContainer;
